function HandWrittenLetterIcon() {
    return (
        <svg
            id="Layer_1"
            data-name="Layer 1"
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 17.76 15.44">
            <g>
                <path
                    fill="#ffffff"
                    d="M8.42,17.6A.65.65,0,0,1,7.77,17V15.28H2a.75.75,0,0,1-.75-.75V3.15A.75.75,0,0,1,2,2.4h9.38a.76.76,0,0,1,.75.75V10h6a.62.62,0,0,1,.64.64V17a.64.64,0,0,1-.64.64ZM8.33,17a.09.09,0,0,0,.09.09h9.7a.09.09,0,0,0,.09-.09V10.8L13.39,14l-.12,0-.1,0-1.05-.69v1.18a.76.76,0,0,1-.75.75h-3ZM2,3a.2.2,0,0,0-.2.2V14.53a.2.2,0,0,0,.2.2h9.38a.2.2,0,0,0,.2-.2V3.15a.2.2,0,0,0-.2-.2Zm11.28,10.5,4.36-2.93H12.12v2.16Z"
                    transform="translate(-1.12 -2.28)"
                />
                <path
                    fill="#ffffff"
                    d="M2,2.51h9.38a.64.64,0,0,1,.64.64v6.93h6.11a.53.53,0,0,1,.53.53V17a.53.53,0,0,1-.53.53H8.42A.53.53,0,0,1,7.89,17V15.17H2a.64.64,0,0,1-.64-.64V3.15h0A.64.64,0,0,1,2,2.51M2,14.84h9.38a.31.31,0,0,0,.31-.31V3.15a.31.31,0,0,0-.31-.31H2a.31.31,0,0,0-.31.31V14.53a.31.31,0,0,0,.31.31m11.28-1.25L18,10.41H12v2.33l1.26.85m0,.35h-.09L12,13.13v1.4a.64.64,0,0,1-.64.64H8.21V17a.2.2,0,0,0,.21.2h9.7a.2.2,0,0,0,.2-.2V10.59l-5,3.33-.09,0M11.37,2.28H2a.87.87,0,0,0-.87.87V14.53A.87.87,0,0,0,2,15.4H7.66V17a.76.76,0,0,0,.75.76h9.71a.76.76,0,0,0,.76-.76V10.61a.76.76,0,0,0-.76-.76H12.24V3.15a.87.87,0,0,0-.87-.87ZM2,14.61a.09.09,0,0,1-.06-.08V3.15A.08.08,0,0,1,2,3.07h9.38a.09.09,0,0,1,.08.08V14.53a.09.09,0,0,1-.08.08H2Zm10.27-4h5l-4,2.67-1-.69v-2Zm1,3.53a.42.42,0,0,0,.21-.06L18.09,11V17l-9.67,0,0-1.53h2.93a.87.87,0,0,0,.87-.87v-1l.81.54h0l0,0,.05,0h.13Z"
                    transform="translate(-1.12 -2.28)"
                />
            </g>
            <path
                fill="#ffffff"
                d="M3.13,4.55H4.85A.11.11,0,0,0,5,4.44a.12.12,0,0,0-.12-.12H3.13A.12.12,0,0,0,3,4.44.11.11,0,0,0,3.13,4.55Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,5.81h7.1a.12.12,0,0,0,.12-.12.12.12,0,0,0-.12-.11H3.13A.11.11,0,0,0,3,5.69.12.12,0,0,0,3.13,5.81Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,7.07h7.1A.12.12,0,0,0,10.35,7a.12.12,0,0,0-.12-.11H3.13A.11.11,0,0,0,3,7,.12.12,0,0,0,3.13,7.07Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,8.33h7.1a.13.13,0,0,0,.12-.12.12.12,0,0,0-.12-.11H3.13A.11.11,0,0,0,3,8.21.12.12,0,0,0,3.13,8.33Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,9.58h7.1a.12.12,0,0,0,.12-.11.13.13,0,0,0-.12-.12H3.13A.12.12,0,0,0,3,9.47.11.11,0,0,0,3.13,9.58Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,10.84h7.1a.12.12,0,0,0,.12-.11.12.12,0,0,0-.12-.12H3.13a.12.12,0,0,0-.12.12A.11.11,0,0,0,3.13,10.84Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M3.13,12.1h7.1a.11.11,0,0,0,.11-.08,0,0,0,0,0,0,0,.12.12,0,0,0-.12-.12H3.13A.12.12,0,0,0,3,12a.11.11,0,0,0,.12.11Z"
                transform="translate(-1.12 -2.28)"
            />
            <path
                fill="#ffffff"
                d="M10.23,13.36a.12.12,0,0,0,.12-.12.12.12,0,0,0-.12-.11H3.13a.11.11,0,0,0-.12.11.12.12,0,0,0,.12.12Z"
                transform="translate(-1.12 -2.28)"
            />
        </svg>
    )
}

export default HandWrittenLetterIcon
